import { render, staticRenderFns } from "./EmployerInformation.vue?vue&type=template&id=bdbff5f2&scoped=true"
import script from "./EmployerInformation.vue?vue&type=script&lang=js"
export * from "./EmployerInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbff5f2",
  null
  
)

export default component.exports